import { render, staticRenderFns } from "./HumanCapitalList.vue?vue&type=template&id=c9f27c4a&scoped=true&"
import script from "./HumanCapitalList.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalList.vue?vue&type=script&lang=js&"
import style0 from "./HumanCapitalList.vue?vue&type=style&index=0&id=c9f27c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f27c4a",
  null
  
)

export default component.exports